import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { BlipChatControlSingleton } from '@hub-workspace/apps/logged-home/src/app/pages/onboarding/utils';

@Component({
    selector: "stepper",
    templateUrl: "./stepper.component.html",
    styleUrls: ["./stepper.component.scss"]
})
export class StepperComponent implements OnInit, OnChanges {
    @Input()
    public currentStep: number = 0;

    @Input()
    public stepsTotal: number = 0;

    public stepsList = [];

    public progressPercent: number = 0;

    public ngOnInit(): void {
        this.generateSteps()
            .markFirstAsActive()
            .verifyWhenWasActiveAndWhenWasCompleted()
            .calculateProgress();
    }

    public ngOnChanges(changes): void {
        this.verifyWhenWasActiveAndWhenWasCompleted()
            .calculateProgress();
    }

    protected verifyWhenWasActiveAndWhenWasCompleted() {
        this.stepsList.map(step => {
            step.completed = step.id < this.currentStep;
            step.active = step.id == this.currentStep;
        });

        return this;
    }

    protected generateSteps() {
        for (let index = 1; index <= this.stepsTotal; index++) {
            this.stepsList.push({
                completed: false,
                active: false,
                id: index
            });
        }

        return this;
    }

    protected markFirstAsActive() {
        this.stepsList[0].active = true;

        return this;
    }

    public calculateProgress() {
        const percent = 100 / this.stepsTotal;
        this.progressPercent = this.currentStep * percent;

        return this;
    }
}
